import { BoxProps } from '@chakra-ui/react';

export const wrapper: BoxProps = {};
